/* @flow */

import Company from 'models/companies/company';

export default class Reset2FAForm {
  company: Company;
  email: string;
  password: string;

  constructor() {
    this.company = null;
    this.email = '';
    this.password = '';
  }

  toRequest() {
    return {
      companyId: this.company ? this.company.id : 0,
      email: this.email,
      password: this.password
    };
  }
}
